import Vue from 'vue'
import moment from 'moment'
Vue.filter('formatcase', function (input) {

  /*
   if (input && input !== null) {
   var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
   input = input == null ? '' : input;
   input = input.toLowerCase();
   return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*!/g, function (match, index, title) {
   if (index > 0 && index + match.length !== title.length &&
   match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
   (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
   title.charAt(index - 1).search(/[^\s-]/) < 0) {
   return match.toLowerCase();
   }

   if (match.substr(1).search(/[A-Z]|\../) > -1) {
   return match;
   }

   return match.charAt(0).toUpperCase() + match.substr(1);
   });

   }
   */
  return input

})

Vue.filter('newline', function (input) {

  if (input) {
    return input.replace(/\n/g, '<br />')
  }

})

Vue.filter('fdate', function (input) {
  if (input) {
    return moment(input).format('MM-DD-YYYY')
  }
})
Vue.filter('fdate1', function (input) {
  if (input) {
    return moment(input).format('MM-DD-YYYY h:mm a')
  }
})
Vue.filter('fdate2', function (input) {
  if (input) {
    return moment(input).format('MM-DD-YYYY h:mm a')
  }
})

Vue.filter('fdate3', function (input) {
  if (input) {
    return moment(input).format('MMM DD, YYYY')
  }
})

Vue.filter('fdate4', function (input) {
  if (input) {
    return moment(input).format('MMM DD, YYYY h:mm a')
  }
})
Vue.filter('ftime', function (input) {
  if (input) {
    var p = moment(input, 'h:mm')

    return moment(p).format('HH:mm')
  }
})
Vue.filter('ftime', function (input) {
  if (input) {
    var p = moment(input, 'h:mm')

    return moment(input).format('h:mm a')
  }
})

Vue.filter('ftimezone', function (input) {

  if (input) {
    var xsm = input.substring(0, 1)
    if (xsm != '-') {

      input = '+ ' + input.substring(0, input.length - 1)
    }
    if (xsm == '-') {
      input = input.charAt(0) + ' ' + input.substr(1)
    }
  }
  return input
})

Vue.filter('des', function (input, val) {
  let refval
  let fval
  if (val) {
    refval = val.replace(/ +/g, '')

  }

  if (input || input == 0) {
    if (refval.toLowerCase() == 'ph' || refval.toLowerCase() == 'combinedchlorine' || refval.toLowerCase() == 'freechlorine') {
      fval = input.toFixed(1)
    } else {
      fval = input
    }

    return fval
  }
})

Vue.filter('rmmillisec', function (input) {

  if (input != '___') {

    var a = input.split(':')

    return a[0] + ':' + a[1]
    //  var a=moment(input).format('h:mm')
    //return a
  } else {
    return input
  }
})

Vue.filter('fdateSec', function (input) {
  if (input) {

    //return moment(input).format('MM-DD-YYYY',' h:mm a');
    return moment(input).startOf('hour').fromNow()
  }
})
Vue.filter('dlink', function (input) {
  if (input) {

    //return moment(input).format('MM-DD-YYYY',' h:mm a');
    return window.baseUrl + 'Documents/CertificationDocuments/' + input
  }
})

//FG - I RENAMED THE LINK BELOW FROM dlinkc to dlinkc_DIGICLARITY
//     It is the code that was delivered from digiclarity in an update
//     but it didn't work for our PUB stuff... I rewrote this filter 
//     once but tht didn't work either
Vue.filter('dlinkc_DIGICLARITY', function (input) {
  if (input) {
    //input = input.slice(7)
    input = input.replace(/^.*\/\/[^\/]+/, '')
    //return moment(input).format('MM-DD-YYYY',' h:mm a');
    return window.baseUrl + '' + input
  }
})

//FG - THIS WAS MY VERSION OF THE FILTER dlinkc
//     I WROTE IT BECAUSE THE DIGICLARITY VERSION   
//     DID NOT SEEM TO WORK BUT ROOPESH SENT
//     A DIFFERENT VERSION OF ComplianceService.cs
//     THAT WORKS WITH THE ORIGINAL VERSION OF THIS
//     FILTER (ABOVE)...NOTE: ComplianceService.cs
//     IS IN THE VISUAL STUDIO CODE
//     IT ALSO DOESN'T WORK FOR OUR PUB STUFF
Vue.filter('dlinkc_FOOF_VERSION_1', function (input) {
  //Find "//" and replace it and everything before it with the base url
  if (input) {
    //FG - line below is for debugging
    var indexOfDoubleSlash=input.indexOf("//")
    var everythingAfterDoubleSlash = input.substring(indexOfDoubleSlash+2)
    return window.baseUrl + everythingAfterDoubleSlash
  }
})
//FG - FOOF - DEC 7 12:18AM - seems the input can simply be returned
//     for this to work for both DEV and PUB
Vue.filter('dlinkc', function (input) {
    return input
})

Vue.filter('phoneformat', function (input) {

  if (input) {
    var numbers = input.replace(/\D/g, ''),
      char = {
        0: '(',
        3: ') ',
        6: ' - '
      }
    input = ''
    for (var i = 0; i < numbers.length; i++) {
      input += (char[i] || '') + numbers[i]
    }
    return input
  }

})



// WEBPACK FOOTER //
// ./src/filters/filters.js